'use client'

import React, { createContext, useState, useContext, useEffect } from 'react'
import { useAuth } from './AuthContext'
import { api } from '../configs/api'

type CalendarDataType = {
    id: string
    name: string
    image?: string
    situation?: string
    email?: string
    phone?: string
    company: {
        id: string
        name: string
    }
}

type CalendarType = {
    events: CalendarDataType[]
    setEvents: (value: CalendarDataType[]) => void
    filteredEvents: CalendarDataType[]
    setFilteredEvents: (value: CalendarDataType[]) => void
    loadCalendar: () => Promise<void>
}

const Calendar = createContext<CalendarType | undefined>(undefined)

export const CalendarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user, unity } = useAuth()
    const [events, setEvents] = useState<CalendarDataType[]>([])
    const [filteredEvents, setFilteredEvents] = useState<CalendarDataType[]>([])

    const loadCalendar = async () => {
        if (!unity || !user) return

        const response = await fetch(`${api}calendar/getData`, {
            method: 'POST',
            body: JSON.stringify({
                userID: user.userID,
                unityID: unity.unityID
            })
        })
        const result = await response.json()

        const formatterEvents = result.list.map((item: any) => {
            return {
                //* start convert yyyy-mm-dd to new Date().toISOString().split('T')[0],
                businessID: item.businessID,
                noteID: item.noteID,
                title: item.company,
                subtitle: item.products,
                author: {
                    name: item.author,
                    image: item.image
                },
                createdAt: item.date,
                users: item.users ?? '',
                start: new Date(item.dateNotify),
                type: 'event',
                description: item.description,
                status: item.status
            }
        })
        setEvents(formatterEvents)
        setFilteredEvents(formatterEvents)
    }

    useEffect(() => {
        //* Carrega eventos do calendário...
        loadCalendar()
    }, [unity, user])

    return (
        <Calendar.Provider
            value={{
                events,
                setEvents,
                filteredEvents,
                setFilteredEvents,
                loadCalendar
            }}
        >
            {children}
        </Calendar.Provider>
    )
}

export function useCalendar() {
    const context = useContext(Calendar)
    if (context === undefined) {
        throw new Error('useCreate must be used within a CalendarProvider')
    }
    return context
}
